import React, {Component} from "react";
import {Accordion, Card, Col} from "react-bootstrap";
import AA from "./aa";
import PropTypes from 'prop-types';
import {faChevronDown, faChevronUp} from "@fortawesome/sharp-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {findLatestResultat} from "./utils";


class UE extends Component {
    static propTypes = {
        item: PropTypes.object.isRequired
    };

    constructor() {
        super();
        this.state = {
            isCollapsed: false
        }
    }

    render() {
        const latestResult = findLatestResultat(this.props.item);

        return (
            <Col className="mb-4" xs={12} sm={6} md={4} lg={3}>
                <Accordion ref="Accordion" defaultActiveKey={1}>
                    <Card>
                      <Accordion.Toggle className="clickable bg-secondary shadow-sm" as={Card.Header} eventKey={1} onClick={() => this.setState({isCollapsed: !this.state.isCollapsed})}>
                            <span className="float-left">
                                {this.props.item.UniteEnseignementCode}
                            </span>
                            <div className="float-right" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "8px"}}>
                                <span>{this.props.item.ProgrammeEtudiantDispense ? "D" : (latestResult !== null ? (<span className="result">{latestResult + "/20"}</span>) : "")}<small>{this.props.item.ProgrammeEtudiantTransfertResultat ? " (T)" : ""}{this.props.item.ProgrammeEtudiantReportResultat ? " (R)" : ""}</small></span>
                                { this.state.isCollapsed
                                    ? <FontAwesomeIcon type={"p"} className={"fa-fw"} icon={faChevronDown}/>
                                    : <FontAwesomeIcon type={"p"} className={"fa-fw"} icon={faChevronUp}/>
                                }
                            </div>

                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={1}>
                            <>
                                <Card.Body>
                                    <h6 className="text-primary text-center">
                                        {this.props.item.UniteEnseignementLibelle}
                                    </h6>

                                    {this.props.item.ResultatEtudiantInscritS1 && <div className="text-right result">S1: {this.props.item.ResultatEtudiantResultatS1 ? this.props.item.ResultatEtudiantResultatS1.toString().padStart(2, '0') : '--'}/20</div>}
                                    {this.props.item.ResultatEtudiantInscritS2 && <div className="text-right result">S2: {this.props.item.ResultatEtudiantResultatS2 ? this.props.item.ResultatEtudiantResultatS2.toString().padStart(2, '0') : '--'}/20</div>}
                                    {this.props.item.ResultatEtudiantInscritS3 && <div className="text-right result">S3: {this.props.item.ResultatEtudiantResultatS3 ? this.props.item.ResultatEtudiantResultatS3.toString().padStart(2, '0') : '--'}/20</div>}

                                    {this.props.item.AAs &&
                                    <div className="mt-4">
                                        <AA item={this.props.item.AAs}/>
                                    </div>}

                                </Card.Body>

                                <Card.Footer className="bg-white">
                                    <span className="float-left">
                                        {
                                            this.props.item.Q1 && this.props.item.Q2 ? "Q1/Q2" :
                                                this.props.item.Q1 ? "Q1" :
                                                    this.props.item.Q2 ? "Q2" : ""
                                        }
                                    </span>
                                    <span className="float-right">
                                        {this.props.item.ECTS}{this.props.item.ECTS !== null && " ECTS"}
                                    </span>
                                </Card.Footer>
                            </>
                        </Accordion.Collapse >
                    </Card>
                </Accordion>
            </Col>
        );
    }
}

export default UE;